import styled from 'styled-components';

export const InlineCode = styled.span`
    background: ${({ theme }) => theme.palette.default.backgrounds.strength.weaker};
    padding: ${({ theme }) => `${theme.spacing(1.5)}${theme.units}`};
    line-height: 2;
`;
